import React from 'react';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import { scorecardSummaryText } from 'shared/components/application_history/scorecard_summary_text';

const t = withLocalePrefix('talent_matching.rediscovery.table.summary_cell');

const SummaryCell = ({ applicationId }: { applicationId: number }) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  return (
    <Stack
      spacing={0.5}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      {application.currentStage && (
        <SecondaryBody>
          {t('reached', { stage: application.currentStage.name })}
        </SecondaryBody>
      )}
      {application.rejectionReason && (
        <SecondaryBody>
          {t('rejected_for', { reason: application.rejectionReason })}
        </SecondaryBody>
      )}
      <SecondaryBody>
        {scorecardSummaryText(application.positiveRatingPercentage)}
      </SecondaryBody>
    </Stack>
  );
};

export default SummaryCell;
